import type { TestResult } from './trf';

export interface ProgressPoint {
  name: string;
  overall: number;
}

/**
 * A candidate's overall across their tests, oldest first: the line of their
 * progress. Tests without an overall yet are left out rather than drawn as
 * a fall to nothing.
 */
export function progressPoints(tests: TestResult[]): ProgressPoint[] {
  return tests
    .filter((test): test is TestResult & { overall: number } => test.overall !== null)
    .slice()
    .sort((a, b) => a.satAt.localeCompare(b.satAt))
    .map((test) => ({ name: test.name, overall: test.overall }));
}

/**
 * The test that is a new personal best, if there is one: the most recent
 * test, when its overall is higher than every overall before it. Never the
 * first test — a best needs something to beat — and never an equal one.
 */
export function personalBest(tests: TestResult[]): string | null {
  const points = progressPoints(tests);
  if (points.length < 2) return null;
  const latest = points[points.length - 1]!;
  const before = Math.max(...points.slice(0, -1).map((p) => p.overall));
  return latest.overall > before ? latest.name : null;
}
